import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Fields of `technicalReview` saved by the block project-technical-review-dc ("Techn. Prüfung -
 * DC") with their payload type (`preparePayloadForGraphQL`). Must match
 * `ProjectTechnicalReviewDcInput`.
 */
const PROJECT_TECHNICAL_REVIEW_DC_FIELD_TYPES = {
  dcInspectedState: 'string',
  dcNotes: 'string',
  expectedDcTimeExpenditureInSeconds: 'number',
  dcInstallationTeamNotes: 'string',
};

export const PROJECT_TECHNICAL_REVIEW_DC_INPUT_FIELDS = Object.keys(
  PROJECT_TECHNICAL_REVIEW_DC_FIELD_TYPES
);

/**
 * `ProjectTechnicalReviewDcInput` from the block object (or the unsaved project): the four fields
 * of `technicalReview`.
 */
export const toProjectTechnicalReviewDcInput = (project) =>
  preparePayloadForGraphQL(project.technicalReview ?? {}, PROJECT_TECHNICAL_REVIEW_DC_FIELD_TYPES);
